/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ThirdPartyLogo, StepCard } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import ActionTemplateCardList from "~/components/ActionTemplates/ActionTemplateCardList";
import filterActionTemplates from "~/components/ActionTemplates/filterActionTemplates";
import Markdown from "~/components/Markdown";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import Section from "~/components/Section/index";
import { resolveUrl } from "~/utils/resolveUrl";
import styles from "./style.module.less";
interface BuiltinActionTemplateListProps {
    templates: ActionTemplateSearchResource[];
    filter?: string;
    onPostSelectionUrlRequested: (template: {
        Type: string;
        Id: string;
    } | string) => LinkHref;
}
function BuiltinActionTemplateList(props: BuiltinActionTemplateListProps) {
    const filteredResults = filterActionTemplates(props.templates, props.filter!);
    const navigation = useSpaceAwareNavigation();
    if (filteredResults.length === 0 && props.filter) {
        return <p className={styles.noBuiltInSteps}>There are no built-in step templates that match your filter criteria.</p>;
    }
    return (<Section sectionHeader="Built-in Step Templates">
            <ActionTemplateCardList>
                {filteredResults.map((template) => {
            return (<StepCard key={template.Type + template.Id} heading={template.Name} subHeading="By Octopus Deploy" description={<Markdown markup={template.Description} noMargins mutedTextColor/>} logo={<ThirdPartyLogo url={resolveUrl(template.Links.Logo)} size={space[40]} isSquare={true}/>} dotpoints={template.Features} primaryAction={{
                    label: "Add Step",
                    href: props.onPostSelectionUrlRequested(template),
                }}/>);
        })}
            </ActionTemplateCardList>
        </Section>);
}
export default BuiltinActionTemplateList;
